import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=48b4edfa&scoped=true&"
import script from "./BasePage.vue?vue&type=script&lang=js&"
export * from "./BasePage.vue?vue&type=script&lang=js&"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=48b4edfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4edfa",
  null
  
)

export default component.exports